export default{
	isAuth: function(key){
		return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
	},
	setItem: function(key,value){
		localStorage.setItem(key,JSON.stringify(value));
		// return  new Promise(function(resolve, reject){
		// 	sessionStorage.setItem(key,JSON.stringify(value));
		// 	resolve(1);
		// });
	},
	getItem: function(key){
		let _value = localStorage.getItem(key);
		// let _value = sessionStorage.getItem(key);
		if(_value == '' || _value == null || _value == undefined || _value == 'undefined'){
			return '';
		}else{
			if(typeof _value == 'string'){
				return JSON.parse(_value);
			}else{
				return '';
			}
		}
	},
	setToken: function(value){
		localStorage.setItem("JL-TOKEN",value);
		// return  new Promise(function(resolve, reject){
		// 	sessionStorage.setItem(key,JSON.stringify(value));
		// 	resolve(1);
		// });
	},
	getToken: function(){
		let _value = localStorage.getItem("JL-TOKEN");
		if(_value == '' || _value == null || _value == undefined || _value == 'undefined'){
			return '';
		}else{
			return _value;
		}
	},
	setUser: function(value){
		localStorage.setItem("JL-USER",JSON.stringify(value));
	},
	getUser: function(){
		let _value = localStorage.getItem("JL-USER");
		if(_value == '' || _value == null || _value == undefined || _value == 'undefined'){
			return '';
		}else{
			if(typeof _value == 'string'){
				return JSON.parse(_value);
			}else{
				return '';
			}
		}
	},
	setProject: function(value){
		localStorage.setItem("JL-PROJECT",JSON.stringify(value));
	},
	getProject: function(){
		let _value = localStorage.getItem("JL-PROJECT");
		if(_value == '' || _value == null || _value == undefined || _value == 'undefined'){
			return '';
		}else{
			if(typeof _value == 'string'){
				return JSON.parse(_value);
			}else{
				return '';
			}
		}
	},
	setPermision: function(value) {
		localStorage.setItem("JL-PERMS", JSON.stringify(value));
	},
	hasPermision: function(value){
		let _value = localStorage.getItem("JL-PERMS");
		if(typeof _value == 'string'){
			let perms = JSON.parse(_value);
			if(Array.isArray(perms)) {
				var len = perms.length;
				for(var i=0;i<len;i++) {
					if (value == perms[i]) {
						return true;
					}
				}
			}
		}
		return false;
	},
	// 文件转base64
	getBase64: function(file) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			let fileResult = "";
			reader.readAsDataURL(file.raw);
			//开始转
			reader.onload = function() {
				fileResult = reader.result;
			};
			//转 失败
			reader.onerror = function(error) {
				reject(error);
			};
			//转 结束 resolve 出去
			reader.onloadend = function() {
				resolve(fileResult);
			};
		});
	}
}
